'strict mode';

// google analytics relies on this global variable
// in order to transmit custom data
window.dataLayer = [];

var dom = {};

var api = {};

var transmissionCallbacks = [];

var googleDataObject = window.dataLayer;

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var setupDom = function(){

	dom.document = $(document);

};

var addEventHandlers = function(){

	dom.document.on('click', '[data-analytics]', function(){

		var analyticsStr = $(this).attr('data-analytics');
		var data;

		if(analyticsStr.length){

			data = JSON.parse($(this).attr('data-analytics'));

			api.transmitData(data);

		}

	});

};

var init = function(){

	setupDom();

	addEventHandlers();

};

api.registerTransmissionCallback = function(fn){

	transmissionCallbacks.push(fn);

};

api.transmitData = function(data){

	var i;

	googleDataObject.push(data);

	if(transmissionCallbacks.length){

		for(i = 0; i < transmissionCallbacks.length; i++){

			transmissionCallbacks[i]();

		}

	}

	transmissionCallbacks = [];

};

api.updateAnalyticsAttr = function($element, data){

	var currentData = JSON.parse($element.attr('data-analytics'));

	var newData = $.extend(currentData, data);

	$element.attr("data-analytics", JSON.stringify(newData));

};

$(init);

module.exports = api;